// extracted by mini-css-extract-plugin
module.exports = {"popupMain":"stroke-styler_popupMain__ua61T"};